"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var RewardBase = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(RewardBase, _Component);

  function RewardBase() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, RewardBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(RewardBase)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "type", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "target", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(RewardBase, [{
    key: "render",
    value: function render() {
      if (this.target) {
        return _react.default.createElement("a", {
          className: "reward-entry",
          "data-reward-type": this.type,
          href: this.target,
          target: "_blank"
        }, this.children);
      }

      return _react.default.createElement("div", {
        className: "reward-entry",
        "data-reward-type": this.type
      }, this.children);
    }
  }]);
  return RewardBase;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "type", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "target", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = RewardBase;